<template>
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <BasicCell :span="1" />
    <BasicCell :span="1" />
    <BasicCell :span="1" />
    <BasicCell
      :span="3"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="id"
      />
      <span>Numéro</span>
    </BasicCell>
    <BasicCell
      :span="13"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="dispositif"
      />
      <span>Dispositif</span>
    </BasicCell>
    <BasicCell :span="10">
      <span>Entreprise</span>
    </BasicCell>
    <BasicCell
      :span="5"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="Etat"
      />
      <span>Etat</span>
    </BasicCell>
    <BasicCell :span="1" />
    <BasicCell :span="1" />
  </div>
</template>

<script setup lang="ts">
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'

  const modelValue = defineModel<string>()
</script>
